export const useDemoClassmates = (classId = null) => {
  // classId required in original useClassmates hook
  return { data: [], isLoading: false, error: null };
};
